<template>
  <v-overlay
    :model-value="processing"
    content-class="w-100 fill-height"
    persistent
  >
    <div class="d-flex fill-height justify-center align-center">
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      />
    </div>
  </v-overlay>
</template>

<script setup>
defineProps({
  processing: Boolean,
});
</script>
